<template>
  <div class="view" id="spot-distance">
    <div class="content" id="browse">
      <div class='inside-closer' v-on:click="close">✖</div>
      <div class='sub-heading padding-20'>Fotoplats</div>
      <div class='heading'><div class='blue-circle'></div> {{spot}}</div>
      <div class='sub-heading padding-40 pad-sides'>
        Foton från platsen
      </div>
      <div v-if="spotPhotosLoaded === true" style='padding: 15px 0px;'>
        <photoFeed v-bind:photos="photos" show-user="true" show-spot="false">
          <div slot="empty">Inga foton från platsen.</div>
        </photoFeed>
      </div>
      <div v-else><loader colorClass='black'></loader></div>
      <div class='padding-80'></div>
      <div class='padding-80'></div>
    </div>
  </div>
</template>

<script>
import loader from '@/components/Loader'
import photoFeed from '@/components/photoFeed'
import firebaseApp from '@/classes/Db'

export default {
  name: 'spotdistance',
  data () {
    return {
      spotPhotosLoaded: false,
      photos: []
    }
  },
  props: ['spot'],
  computed: {
    photosOrdered () {

    }
  },
  methods: {
    close () {
      this.$store.commit('updateSpotAtDistance', null)
    },
    getPhotosFromSpot () {
      firebaseApp.database().ref('photos/' + this.spot).orderByChild('score').limitToLast(29).once('value').then((snapshot) => {
        this.spotPhotosLoaded = true
        snapshot.forEach((shot) => {
          this.photos.push(shot.val())
        })
      })
    }
  },
  mounted () {
    this.getPhotosFromSpot()
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Spot from distance')
    }
  },
  beforeDestroy () {

  },
  components: { loader, photoFeed }
}
</script>

<style>
#spot-distance {
  position: absolute;
  min-height:100vh;
  top: 0px;
  left: 0px;
	background-color: #fff;
	z-index: 9999;
}
.buttons {
  padding: 15px;
  padding-top: 0px;
  width: 100%;
  box-sizing: border-box;
}
.upload-button, .browse {
  margin-top: 15px;
}
.spot-winner {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-color: #131313;
  background-color: #f4f4f4;
  border-top: 0px solid #fff;
  border-bottom: 0px solid #fff;
  height: 170px;
  width: 100%;
  margin: 15px 0px;
  margin-bottom: 10px;
}
.eye {
  position: relative;
}
.eye:before {
  content: "";
  width: 25px;
  height: 15px;
  background-image: url('./../assets/eye.svg');
  display: block;
  position: absolute;
  top: 10px;
  right: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Spotdistance.vue?41f81901